<template>
<div>
    <card class="login-card">
        <template slot="header">
            <i class="material-icons">vpn_lock</i>
            <strong class="ml-2">Login</strong>
        </template>

        <template slot="body">
            <form @submit.prevent="onSubmit">
                <div :disabled="is_loading" class="flex">
                    <div class="flex-50 mr-3">
                        <label for="username">Username</label>
                        <input id="username" autofocus required type="text" v-model="data.username" />
                    </div>

                    <div class="flex-50 ml-3">
                        <label for="password">Password</label>
                        <password-input
                            id="password"
                            required="required"
                            @change="(p) => data.password = p"
                            :input-value="data.password"
                            label="password"></password-input>
                    </div>
                </div>

                <div class="flex ai-c jc-sb mt-5">
                    <div class="danger-text flex-0 ws-nw">{{ error_message }}</div>

                    <div class="flex flex-a jc-fe">
                        <div v-show="is_loading" class="flex ai-c mr-2">
                            <img src="../assets/img/loading-black-32.gif" alt="loading" />
                        </div>

                        <button :disabled="is_loading" type="submit">Login</button>
                    </div>
                </div>
            </form>
        </template>
    </card>
</div>
</template>

<script>
import store from "@/store"

export default {
    name: "login-page",

    data () {
        return {
            data: {
                password: "",
                username: ""
            },
            error_message: "",
            is_loading: false
        }
    },

    mounted () {
        const token = store.state.token

        if (token) {
            this.$router.push("/")
        }
    },

    methods: {
        async onSubmit () {
            this.is_loading = true

            try {
                await store.dispatch("attemptLogin", this.data)

                this.$router.push("/")
            } catch (ex) {
                this.error_message = ex
            } finally {
                this.is_loading = false
            }
        }
    }
}
</script>

<style>
.login-card {
    margin: 5vh auto 0;
    max-width: 1000px;
}
</style>



// WEBPACK FOOTER //
// src/pages/LoginPage.vue